// How many of the library's videos this account can't play yet, per collection, for Profile →
// Settings' VIDEOS (2026-10-20, Seán's spec): counted from the catalogue (the gallery's
// /sitemaps/videos/showcases-lite.json) with the gallery's own check (videoCards.js
// getHasVideoAccess), never from the calendar year: on 1 January there may be no new videos to
// unlock yet. A free video ("anybody") is never locked. A video counts in its showcase's
// collection (a Masterclass showcase, else the Workshop).

import {computed, ref} from "vue";
import {getHasVideoAccess} from "@/components/Video/videoCards";

const showcases = ref(null); // shared: fetched once per page load

async function fetchShowcases() {
  try {
    const response = await fetch("/sitemaps/videos/showcases-lite.json");
    showcases.value = response.ok ? await response.json() : {};
  } catch (error) {
    console.error(`useLockedVideos: ${error}`);
    showcases.value = {};
  }
}

const getCollection = (showcase) => (/Masterclass/i.test(showcase) ? "masterclass" : "workshop");

function getLockedCounts(catalogue, user) {
  const counts = {workshop: 0, masterclass: 0};
  for (const [showcase, {videos = {}} = {}] of Object.entries(catalogue || {})) {
    if (!/\d{4}/.test(showcase)) continue;
    for (const [hash, video] of Object.entries(videos)) {
      if (video?.privacy === "anybody") continue;
      if (getHasVideoAccess({video, hash, showcase, user, isSignedIn: true})) continue;
      counts[getCollection(showcase)] += 1;
    }
  }
  return counts;
}

// user: a ref; {lockedCounts: {workshop, masterclass} (null until loaded), hasLockedVideos}
export default function useLockedVideos(user) {
  if (!showcases.value) fetchShowcases();
  const lockedCounts = computed(() => {
    if (!showcases.value || !user.value) return null;
    return getLockedCounts(showcases.value, user.value);
  });
  const hasLockedVideos = computed(() => {
    const counts = lockedCounts.value;
    return Boolean(counts && counts.workshop + counts.masterclass > 0);
  });
  return {lockedCounts, hasLockedVideos};
}
